import Link from 'next/link';

import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import { TEXT_TYPE } from '@/components/@base/typography/text/type';
import XImage from '@/components/@base/x-image';

import imagesList from '@/constant/images-list';
import { pageLevelLocalization } from '@/constant/localization';

import Unit from './unit';
import getContactInfo from '../../helper/getContactInfo';

const {
  content: { contact: contactLocalization },
} = pageLevelLocalization;

export const unitsData = [
  {
    title: contactLocalization.unit_one,
    subTitle: contactLocalization.support_unit,
  },
  {
    title: contactLocalization.unit_two,
    subTitle: contactLocalization.consulting_unit,
  },
  {
    title: contactLocalization.unit_three,
    subTitle: contactLocalization.development_unit,
  },
  {
    title: contactLocalization.unit_four,
    subTitle: contactLocalization.contact_with_zhaket,
  },
];

export default function Units() {
  const contactInfo = getContactInfo();
  return (
    <Container className='flex flex-1 flex-col gap-5 md:flex-row md:gap-10'>
      <Link prefetch={false}
        href={`tel:${process.env.NEXT_PUBLIC_PHONE}`}
        className='flex max-h-24 min-w-44 gap-2 rounded-lg bg-[#fff5e680] px-4 py-4 md:flex-col md:justify-center md:py-0'
      >
        <XImage src={imagesList.icons.phoneCallIcon} alt='location' width={22} height={22} />
        <Text
          type={TEXT_TYPE.SPAN}
          className='text-lg font-medium leading-6 tracking-[-0.1em] text-[#B47510]'
        >
          <Text type={TEXT_TYPE.SPAN} className='text-2xl'>
            {contactInfo.PHONE_NUMBER?.slice(3)}
          </Text>{' '}
          {contactInfo.PHONE_NUMBER?.slice(0, 3)}
        </Text>
      </Link>
      <Container className='grid w-full grid-cols-2 gap-4 md:grid-cols-4'>
        {unitsData.map((item, index) => (
          <Unit
            key={index}
            unitNumber={index + 1}
            title={item.title}
            subTitle={item.subTitle}
          />
        ))}
      </Container>
    </Container>
  );
}
